import { render, staticRenderFns } from "./TheCookie.vue?vue&type=template&id=8feae206&scoped=true&"
import script from "./TheCookie.vue?vue&type=script&lang=js&"
export * from "./TheCookie.vue?vue&type=script&lang=js&"
import style0 from "./TheCookie.vue?vue&type=style&index=0&id=8feae206&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8feae206",
  null
  
)

export default component.exports